import React, { useState, useEffect } from 'react';
import './App.css';
import Dashboard from './pages/Dashboard';
import ClientesPage from './pages/ClientesPage';
import Financeiro from './pages/Financeiro';
import Login from './pages/Login';
import { authService } from './services/authService';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('dashboard');
  const [initialLocalidade, setInitialLocalidade] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    setIsLoading(true);
    try {
      if (authService.isAuthenticated()) {
        const response = await authService.verify();
        if (response.success) {
          setIsAuthenticated(true);
          setUser(response.user);
        } else {
          setIsAuthenticated(false);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      setIsAuthenticated(false);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLoginSuccess = () => {
    const userData = authService.getUser();
    setUser(userData);
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setIsAuthenticated(false);
      setUser(null);
      setCurrentPage('dashboard');
    }
  };

  const handleNavigateToClientes = (localidade = null) => {
    setInitialLocalidade(localidade);
    setCurrentPage('clientes');
  };

  const handleNavigateToDashboard = () => {
    setInitialLocalidade(null);
    setCurrentPage('dashboard');
  };

  const handleNavigateToFinanceiro = () => {
    setCurrentPage('financeiro');
  };

  if (isLoading) {
    return (
      <div className="App">
        <div className="loading">⏳ Carregando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="App">
      <header className="header">
        <div className="header-logo">
          <img 
            src={require('./assets/logo-RedeBr.png')} 
            alt="RedeBr Logo" 
            className="logo"
            onClick={handleNavigateToDashboard}
            style={{ cursor: 'pointer' }}
          />
        </div>
        <p>Sistema de Visualização de Clientes - RJ</p>
        <div className="header-user">
          <span className="user-info">👤 {user?.username}</span>
          <button className="btn-logout" onClick={handleLogout}>
            🚪 Sair
          </button>
        </div>
      </header>

      {currentPage === 'dashboard' && (
        <Dashboard 
          onNavigateToClientes={handleNavigateToClientes}
          onNavigateToFinanceiro={handleNavigateToFinanceiro}
        />
      )}

      {currentPage === 'clientes' && (
        <ClientesPage 
          initialLocalidade={initialLocalidade}
          onNavigateToDashboard={handleNavigateToDashboard}
        />
      )}

      {currentPage === 'financeiro' && (
        <Financeiro 
          onNavigateToDashboard={handleNavigateToDashboard}
        />
      )}
    </div>
  );
}

export default App;

